import { MutationFunction, gql, useMutation } from '@apollo/client';

import {
  useRsvpMenu_createRsvpForEvent,
  useRsvpMenu_createRsvpForEventVariables,
} from './graphql-types/useRsvpMenu_createRsvpForEvent';
import {
  useRsvpMenu_updateRsvpResponse,
  useRsvpMenu_updateRsvpResponseVariables,
} from './graphql-types/useRsvpMenu_updateRsvpResponse';

const CREATE_RSVP_MUTATION = gql`
  mutation useRsvpMenu_createRsvpForEvent($input: CreateRsvpForEventInput!) {
    createRsvpForEvent(input: $input) {
      rsvp {
        _id
        response
        eventV2 {
          _id
          currentUserRsvp {
            _id
            response
          }
        }
      }
    }
  }
`;

const UPDATE_RSVP_MUTATION = gql`
  mutation useRsvpMenu_updateRsvpResponse($input: UpdateRsvpResponseInput!) {
    updateRsvpResponse(input: $input) {
      rsvp {
        _id
        response
        eventV2 {
          _id
          currentUserRsvp {
            _id
            response
          }
        }
      }
    }
  }
`;

export const useRsvpMenu = (): {
  isLoading: boolean;
  createRsvpForEvent: MutationFunction<
    useRsvpMenu_createRsvpForEvent,
    useRsvpMenu_createRsvpForEventVariables
  >;
  updateRsvpResponse: MutationFunction<
    useRsvpMenu_updateRsvpResponse,
    useRsvpMenu_updateRsvpResponseVariables
  >;
} => {
  const [createRsvpForEvent, { loading: createRsvpLoading }] = useMutation<
    useRsvpMenu_createRsvpForEvent,
    useRsvpMenu_createRsvpForEventVariables
  >(CREATE_RSVP_MUTATION);

  const [updateRsvpResponse, { loading: updateRsvpLoading }] = useMutation<
    useRsvpMenu_updateRsvpResponse,
    useRsvpMenu_updateRsvpResponseVariables
  >(UPDATE_RSVP_MUTATION);

  return {
    isLoading: createRsvpLoading || updateRsvpLoading,
    createRsvpForEvent,
    updateRsvpResponse,
  };
};
